import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const NAVY = '#0d2137';
const GREEN = '#1a6b3c';
const RED = '#c41e3a';

export default function ForgotPassword() {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) { toast.error('Please enter your username'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { username });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(135deg, ${NAVY} 0%, #1e3a5f 100%)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '40px 36px', width: '100%', maxWidth: 380, boxShadow: '0 24px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 20, fontWeight: 900, color: NAVY }}>DHA MEDICAL CENTRE</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: 3, margin: '8px auto', width: 120 }}>
            <div style={{ flex: 1, background: RED }} />
            <div style={{ flex: 1, background: '#fff', border: '1px solid #ddd' }} />
            <div style={{ flex: 1, background: GREEN }} />
          </div>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📧</div>
            <h3 style={{ color: NAVY, marginBottom: 8 }}>Email Sent!</h3>
            <p style={{ color: '#64748b', fontSize: 13, marginBottom: 20 }}>
              Password reset link has been sent to your registered email. Check your inbox.
            </p>
            <Link to="/login" style={{ color: NAVY, fontWeight: 600, fontSize: 13 }}>← Back to Login</Link>
          </div>
        ) : (
          <>
            <h3 style={{ color: NAVY, marginBottom: 6, fontSize: 18, fontWeight: 800 }}>Forgot Password</h3>
            <p style={{ color: '#64748b', fontSize: 12, marginBottom: 20 }}>Enter your username and we'll send a reset link to your registered email.</p>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  autoFocus
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 7, border: '1.5px solid #d1d5db', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', padding: '11px', borderRadius: 7, background: loading ? '#94a3b8' : NAVY, color: '#fff', fontWeight: 700, fontSize: 15, border: 'none', cursor: loading ? 'not-allowed' : 'pointer' }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <Link to="/login" style={{ color: '#64748b', fontSize: 12 }}>← Back to Login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
